module.exports = __webpack_public_path__ + "img/icon_order.1da10d61.png";